import {
    GET_TRIP_BY_ID_FAIL,
    GET_TRIP_BY_ID_REQUEST,
    GET_TRIP_BY_ID_SUCCESS, SET_BOOKING_TYPE,
    SET_TRIP_ROOMS
} from "../constants/tripConstants";

const defaultTripState = {loading: false, data: {}};
export const getTripReducer = (state = defaultTripState, action) => {
    switch (action.type) {
        case GET_TRIP_BY_ID_REQUEST:
            return {loading: true, data: {}};
        case GET_TRIP_BY_ID_SUCCESS:
            return {loading: false, data: action.payload};
        case GET_TRIP_BY_ID_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
};

export const getTripRoomsReducer = (state = [], action) => {
    switch (action.type) {
        case SET_TRIP_ROOMS:
            return action.payload;
        default:
            return state;
    }
};

export const bookingTypeReducer = (state = 'pay', action) => {
    switch (action.type) {
        case SET_BOOKING_TYPE:
            return action.payload;
        default:
            return state;
    }
};